import React from 'react';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const CookieConsentBanner = () => {
  const { isBannerVisible, acceptAnalytics, declineAnalytics } = useCookieConsent();

  if (!isBannerVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm w-full px-3">
      <div className="bg-[#1F11ED] text-white rounded-2xl shadow-2xl border border-white/20 p-4">
        <p className="text-sm font-semibold">Cookies & Analytics</p>
        <p className="mt-2 text-xs text-white/80">
          We use essential cookies plus optional Google Analytics to understand how Receevit® is used. Analytics only runs if you allow it.
        </p>
        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            className="w-full px-3 py-2 rounded-xl border border-white/40 text-xs font-semibold text-white hover:bg-white/10 transition"
            onClick={declineAnalytics}
          >
            Decline
          </button>
          <button
            type="button"
            className="w-full px-3 py-2 rounded-xl bg-white text-[#1F11ED] text-xs font-semibold hover:bg-blue-50 transition"
            onClick={acceptAnalytics}
          >
            Allow
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;

